// kpiReducer.js
import { SET_KPI_DATA } from "../Action/EordersDataAction";

const initialState = {
  kpiData: null, // Initial state for KPI data
};

const EorderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_KPI_DATA:
      return {
        ...state,
        kpiData: action.payload, // Update the state with the new KPI data
      };
    default:
      return state;
  }
};

export default EorderReducer;